import { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';

import { useToasts } from 'features/toaster/useToasts';

import { useAiCompanionSidebarInternal } from '../AiCompanionSidebarContext';
import messages from './messages';
import type { SubjectEntity } from '../types';
import { getSubjectText } from '../utils/companionEndpoints';

type SendSubjectMessage = (text: string, subject?: SubjectEntity) => void;

export const useSubjectPrompt = (onSend: SendSubjectMessage) => {
  const { formatMessage } = useIntl();
  const { showErrorToast } = useToasts();
  const { pendingSubject, consumeSubject } = useAiCompanionSidebarInternal();
  const latest = useRef({ onSend, showErrorToast, formatMessage });
  latest.current = { onSend, showErrorToast, formatMessage };

  useEffect(() => {
    if (!pendingSubject) return;

    consumeSubject();
    if (pendingSubject.prompt) {
      latest.current.onSend(pendingSubject.prompt, pendingSubject.entity);
      return;
    }
    if (!pendingSubject.entity) return;

    getSubjectText(pendingSubject.entity.type)
      .then(({ text }) => latest.current.onSend(text, pendingSubject.entity))
      .catch(() =>
        latest.current.showErrorToast(
          latest.current.formatMessage(messages.subjectFailed)
        )
      );
  }, [pendingSubject, consumeSubject]);
};
